
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30593',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30593",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55043",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8185",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11637",
  "I18n": "static-7.1643",
  "quartz": "static-1.7243",
  "quartz-config": "static-1.1021",
  "quartz-core": "static-1.6462",
  "react-dlb": "static-1.83",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "reselect": "static-3.7",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.839",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55030",
  "feedback-utils": "static-1.55034",
  "forms-embed-utils-lib": "static-1.4627",
  "forms-utils-lib": "static-1.12893",
  "foundations-assets": "static-1.5037",
  "foundations-components": "static-1.8256",
  "foundations-theming": "static-1.4601",
  "hub-http": "static-1.6384",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11944",
  "icons": "static-2.661",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.4035",
  "raven": "static-3.5925",
  "react": "static-7.189",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16864",
  "react-select-plus": "static-1.107",
  "react-utils": "static-2.5458",
  "react-virtualized": "static-2.101",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.490",
  "tinymce-plugins": "static-1.57935",
  "transmute": "static-2.85",
  "ui-images": "static-2.1199",
  "UIComponents": "static-3.8583",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3518",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3520",
  "quartz-webpack": "static-1.3467",
  "foundations-theming-specialty": "static-1.2317",
  "property-description-translator": "static-1.4002",
  "HeadJS": "static-2.775",
  "framer-motion": "static-1.74",
  "hs-test-utils-bend-plugin": "static-1.3296",
  "msw": "static-1.39",
  "testing-library": "static-1.154",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.224",
  "moment-timezone": "static-5.85",
  "jasmine": "static-4.4488",
  "jasmine-runner": "static-1.6620",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.850",
  "hubspotter-http": "static-1.4768",
  "mobile-manifest-mixins": "static-1.550",
  "module-federation": "static-1.28",
  "quartz-auth": "static-1.918",
  "quartz-head": "static-1.908",
  "quartz-i18n": "static-1.918",
  "quartz-routing": "static-1.673",
  "quartz-test": "static-1.918",
  "quartz-tracking": "static-1.622",
  "trellis-components": "static-1.2283",
  "ui-fonts": "static-1.899",
  "usage-tracker-container": "static-1.7505",
  "usage-tracker-core": "static-1.7365",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.159",
  "conversations-skeleton-state": "static-1.7411",
  "reference-resolvers": "static-1.8340",
  "sanitize-text": "static-1.8310",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10526",
  "sanitize": "static-1.4639",
  "outpost": "static-1.4331",
  "rpc-client-utils": "static-1.4822",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4525",
  "floating-ui": "static-1.59",
  "hs-story-utils": "static-1.9587",
  "react-aria": "static-1.68",
  "react-create-root-preference": "static-1.42",
  "tanstack-table": "static-1.57",
  "trellis-assets": "static-1.2264",
  "bend-plugin-foundations-theming": "static-1.3084",
  "foundations-theming-base": "static-1.3586",
  "stylex": "static-1.36",
  "hs-locale-management": "static-1.200",
  "csstype": "static-1.50",
  "web-vitals": "static-1.8",
  "ai-components-ui-library": "static-1.9379",
  "atom": "static-1.5238",
  "codemirror": "static-5.97",
  "content-assistance-lib": "static-1.8011",
  "ContentUtils": "static-1.68861",
  "data-token-picker": "static-1.16703",
  "file-manager-components": "static-1.24114",
  "FileManagerCore": "static-1.39613",
  "FileManagerLib": "static-1.39754",
  "frontend-preferences-client": "static-1.8092",
  "hub-http-contrib": "static-1.3207",
  "interframe": "static-3.4920",
  "layout-dnd-components": "static-1.12768",
  "layout-dnd-utils": "static-1.11743",
  "property-translator": "static-1.5558",
  "react-codemirror": "static-1.10794",
  "react-colorpicker": "static-2.10371",
  "reference-resolvers-lite": "static-1.8261",
  "rich-text-lib": "static-1.20122",
  "tinymce-data": "static-1.40906",
  "tinymce-themes": "static-1.56791",
  "ui-addon-emoji-picker": "static-1.10046",
  "ui-addon-sales-email": "static-1.5375",
  "ui-brand-identity-lib": "static-1.15894",
  "bender-build-tools": "static-1.3301",
  "hub-http-shared-msw-handlers": "static-1.10377",
  "hubspotter-http-shared-msw-handlers": "static-1.10375",
  "usage-tracker-session-replay": "static-1.5201",
  "base-ui": "static-1.16",
  "react-day-picker": "static-1.5",
  "trellis-theming": "static-1.1111",
  "tanstack-virtual": "static-1.32",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.232",
  "chirp-fetch": "static-1.2052",
  "chatspot-core": "static-1.22141",
  "copilot-toolkit": "static-1.11565",
  "customer-data-objects-ui-components": "static-1.13194",
  "data-fetching-client": "static-1.9822",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4923",
  "ui-addon-video-player": "static-1.8868",
  "ui-coaching-tips": "static-1.29033",
  "usage-tracker": "static-1.7515",
  "cms-field-types": "static-1.4977",
  "content-icons-ui": "static-1.2275",
  "integrations-lib": "static-1.16696",
  "customer-data-objects": "static-1.7842",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1313",
  "apollo-link-hub-http": "static-2.4815",
  "apollo-stack-hubspot": "static-3.88",
  "graphql": "static-1.84",
  "immer": "static-1.33",
  "immerable": "static-1.4313",
  "ui-addon-iframeable": "static-1.9240",
  "video-components-external": "static-1.11834",
  "video-data-lib": "static-1.35492",
  "audio-components": "static-1.6167",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29608",
  "FileManagerImages": "static-1.37265",
  "foundations-components-legacy": "static-1.1281",
  "html-to-image": "static-1.56",
  "react-immutable-proptypes": "static-2.8",
  "redux-toolkit": "static-1.7",
  "salesImages": "static-1.528",
  "ui-universal-auth": "static-1.9172",
  "urlinator": "static-1.4696",
  "video-components": "static-1.13836",
  "video-embed": "static-1.36326",
  "ts-schema": "static-1.4199",
  "ContentData": "static-1.68936",
  "layout-data-lib": "static-1.10068",
  "react-dnd-compat": "static-1.4778",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1706",
  "external-options-client-types": "static-1.4245",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7058",
  "hs-promise-utils": "static-1.5757",
  "inbound-db-properties-service-client": "static-1.3965",
  "NamespacedHubStyle": "static-2.9171",
  "growth-onboarding-confetti": "static-1.3229",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11313",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5660",
  "magpie-types": "static-1.5120",
  "simple-logging-lib": "static-1.3212",
  "avatar-components": "static-1.2662",
  "customer-data-ui-utilities": "static-1.9987",
  "growth-onboarding-feedback-components": "static-1.6743",
  "flux-actions": "static-1.351",
  "hubspot-apollo-client": "static-1.5043",
  "integrations-error-boundary-lib": "static-1.14111",
  "integrations-tracking-lib": "static-1.5770",
  "laboratory-lib": "static-3.7314",
  "native-integrations-shared-strings": "static-1.7943",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10423",
  "unified-auth": "static-1.686",
  "breeze-engine-core": "static-1.591",
  "ably": "static-2.2",
  "highlight.js": "static-1.81",
  "navigation-messaging": "static-1.7789",
  "content-media-composition-data-lib": "static-1.12861",
  "content-media-compositions": "static-2.16868",
  "idb-keyval": "static-1.46",
  "media-bridge-lib": "static-1.19218",
  "unified-auth-core-lib": "static-1.968",
  "social-insights-client-types": "static-1.22519",
  "advanced-menus-core": "static-1.15406",
  "advanced-menus-lib": "static-1.12303",
  "ExportDialog": "static-6.10542",
  "ui-memberships-settings-lib": "static-1.34508",
  "conditional-properties-service-client": "static-1.3916",
  "crm-pipelines-api-client-types": "static-1.4256",
  "fdsr-migration-layer": "static-1.177",
  "framework-builder-read-service-client": "static-1.4124",
  "framework-data-schema-quick-fetch": "static-1.6963",
  "inbound-db-meta-service-client": "static-1.3705",
  "multi-currency-client-types": "static-1.3809",
  "persist-promise": "static-1.3863",
  "foundations-components-test-utils": "static-1.5739",
  "reactive-lib": "static-1.888",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.502",
  "universal-page-editor-lib": "static-1.3176",
  "adobe-sign-auth-lib": "static-1.176",
  "ads-unified-auth-lib": "static-1.660",
  "google-sheets-integration-lib": "static-1.741",
  "microsoft-drive-integration-lib": "static-1.878",
  "surveymonkey-integration-lib": "static-1.193",
  "slack-ui-library": "static-1.10561",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3893",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15405",
  "simple-menus-lib": "static-1.16922",
  "crm-record-cards-service-types": "static-1.3703",
  "location-customization-utils-lib": "static-1.9754",
  "react-flip-move": "static-1.73"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30593",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55043",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8185",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11637",
  "I18n": "/I18n/static-7.1643",
  "quartz": "/quartz/static-1.7243",
  "quartz-config": "/quartz-config/static-1.1021",
  "quartz-core": "/quartz-core/static-1.6462",
  "react-dlb": "/react-dlb/static-1.83",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reselect": "/reselect/static-3.7",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.839",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55030",
  "feedback-utils": "/feedback-utils/static-1.55034",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4627",
  "forms-utils-lib": "/forms-utils-lib/static-1.12893",
  "foundations-assets": "/foundations-assets/static-1.5037",
  "foundations-components": "/foundations-components/static-1.8256",
  "foundations-theming": "/foundations-theming/static-1.4601",
  "hub-http": "/hub-http/static-1.6384",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11944",
  "icons": "/icons/static-2.661",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.4035",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.189",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16864",
  "react-select-plus": "/react-select-plus/static-1.107",
  "react-utils": "/react-utils/static-2.5458",
  "react-virtualized": "/react-virtualized/static-2.101",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.490",
  "tinymce-plugins": "/tinymce-plugins/static-1.57935",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1199",
  "UIComponents": "/UIComponents/static-3.8583",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3518",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3520",
  "quartz-webpack": "/quartz-webpack/static-1.3467",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2317",
  "property-description-translator": "/property-description-translator/static-1.4002",
  "HeadJS": "/HeadJS/static-2.775",
  "framer-motion": "/framer-motion/static-1.74",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3296",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.154",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.224",
  "moment-timezone": "/moment-timezone/static-5.85",
  "jasmine": "/jasmine/static-4.4488",
  "jasmine-runner": "/jasmine-runner/static-1.6620",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.850",
  "hubspotter-http": "/hubspotter-http/static-1.4768",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.550",
  "module-federation": "/module-federation/static-1.28",
  "quartz-auth": "/quartz-auth/static-1.918",
  "quartz-head": "/quartz-head/static-1.908",
  "quartz-i18n": "/quartz-i18n/static-1.918",
  "quartz-routing": "/quartz-routing/static-1.673",
  "quartz-test": "/quartz-test/static-1.918",
  "quartz-tracking": "/quartz-tracking/static-1.622",
  "trellis-components": "/trellis-components/static-1.2283",
  "ui-fonts": "/ui-fonts/static-1.899",
  "usage-tracker-container": "/usage-tracker-container/static-1.7505",
  "usage-tracker-core": "/usage-tracker-core/static-1.7365",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.159",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7411",
  "reference-resolvers": "/reference-resolvers/static-1.8340",
  "sanitize-text": "/sanitize-text/static-1.8310",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10526",
  "sanitize": "/sanitize/static-1.4639",
  "outpost": "/outpost/static-1.4331",
  "rpc-client-utils": "/rpc-client-utils/static-1.4822",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4525",
  "floating-ui": "/floating-ui/static-1.59",
  "hs-story-utils": "/hs-story-utils/static-1.9587",
  "react-aria": "/react-aria/static-1.68",
  "react-create-root-preference": "/react-create-root-preference/static-1.42",
  "tanstack-table": "/tanstack-table/static-1.57",
  "trellis-assets": "/trellis-assets/static-1.2264",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3084",
  "foundations-theming-base": "/foundations-theming-base/static-1.3586",
  "stylex": "/stylex/static-1.36",
  "hs-locale-management": "/hs-locale-management/static-1.200",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.8",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9379",
  "atom": "/atom/static-1.5238",
  "codemirror": "/codemirror/static-5.97",
  "content-assistance-lib": "/content-assistance-lib/static-1.8011",
  "ContentUtils": "/ContentUtils/static-1.68861",
  "data-token-picker": "/data-token-picker/static-1.16703",
  "file-manager-components": "/file-manager-components/static-1.24114",
  "FileManagerCore": "/FileManagerCore/static-1.39613",
  "FileManagerLib": "/FileManagerLib/static-1.39754",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8092",
  "hub-http-contrib": "/hub-http-contrib/static-1.3207",
  "interframe": "/interframe/static-3.4920",
  "layout-dnd-components": "/layout-dnd-components/static-1.12768",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11743",
  "property-translator": "/property-translator/static-1.5558",
  "react-codemirror": "/react-codemirror/static-1.10794",
  "react-colorpicker": "/react-colorpicker/static-2.10371",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8261",
  "rich-text-lib": "/rich-text-lib/static-1.20122",
  "tinymce-data": "/tinymce-data/static-1.40906",
  "tinymce-themes": "/tinymce-themes/static-1.56791",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10046",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5375",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15894",
  "bender-build-tools": "/bender-build-tools/static-1.3301",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10377",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10375",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5201",
  "base-ui": "/base-ui/static-1.16",
  "react-day-picker": "/react-day-picker/static-1.5",
  "trellis-theming": "/trellis-theming/static-1.1111",
  "tanstack-virtual": "/tanstack-virtual/static-1.32",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.232",
  "chirp-fetch": "/chirp-fetch/static-1.2052",
  "chatspot-core": "/chatspot-core/static-1.22141",
  "copilot-toolkit": "/copilot-toolkit/static-1.11565",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13194",
  "data-fetching-client": "/data-fetching-client/static-1.9822",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4923",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8868",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29033",
  "usage-tracker": "/usage-tracker/static-1.7515",
  "cms-field-types": "/cms-field-types/static-1.4977",
  "content-icons-ui": "/content-icons-ui/static-1.2275",
  "integrations-lib": "/integrations-lib/static-1.16696",
  "customer-data-objects": "/customer-data-objects/static-1.7842",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1313",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4815",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.88",
  "graphql": "/graphql/static-1.84",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4313",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9240",
  "video-components-external": "/video-components-external/static-1.11834",
  "video-data-lib": "/video-data-lib/static-1.35492",
  "audio-components": "/audio-components/static-1.6167",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29608",
  "FileManagerImages": "/FileManagerImages/static-1.37265",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1281",
  "html-to-image": "/html-to-image/static-1.56",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "salesImages": "/salesImages/static-1.528",
  "ui-universal-auth": "/ui-universal-auth/static-1.9172",
  "urlinator": "/urlinator/static-1.4696",
  "video-components": "/video-components/static-1.13836",
  "video-embed": "/video-embed/static-1.36326",
  "ts-schema": "/ts-schema/static-1.4199",
  "ContentData": "/ContentData/static-1.68936",
  "layout-data-lib": "/layout-data-lib/static-1.10068",
  "react-dnd-compat": "/react-dnd-compat/static-1.4778",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1706",
  "external-options-client-types": "/external-options-client-types/static-1.4245",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7058",
  "hs-promise-utils": "/hs-promise-utils/static-1.5757",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3965",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9171",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3229",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11313",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5660",
  "magpie-types": "/magpie-types/static-1.5120",
  "simple-logging-lib": "/simple-logging-lib/static-1.3212",
  "avatar-components": "/avatar-components/static-1.2662",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9987",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6743",
  "flux-actions": "/flux-actions/static-1.351",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5043",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14111",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5770",
  "laboratory-lib": "/laboratory-lib/static-3.7314",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7943",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10423",
  "unified-auth": "/unified-auth/static-1.686",
  "breeze-engine-core": "/breeze-engine-core/static-1.591",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.81",
  "navigation-messaging": "/navigation-messaging/static-1.7789",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12861",
  "content-media-compositions": "/content-media-compositions/static-2.16868",
  "idb-keyval": "/idb-keyval/static-1.46",
  "media-bridge-lib": "/media-bridge-lib/static-1.19218",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.968",
  "social-insights-client-types": "/social-insights-client-types/static-1.22519",
  "advanced-menus-core": "/advanced-menus-core/static-1.15406",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12303",
  "ExportDialog": "/ExportDialog/static-6.10542",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34508",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3916",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4256",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.177",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4124",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6963",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3705",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3809",
  "persist-promise": "/persist-promise/static-1.3863",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5739",
  "reactive-lib": "/reactive-lib/static-1.888",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.502",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3176",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.176",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.660",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.741",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.878",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.193",
  "slack-ui-library": "/slack-ui-library/static-1.10561",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3893",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15405",
  "simple-menus-lib": "/simple-menus-lib/static-1.16922",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3703",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9754",
  "react-flip-move": "/react-flip-move/static-1.73"
}
};
